module.exports = __webpack_public_path__ + "static/media/restaurant-7.e1dc4e73.jpg";